import { ChannelPayloadFilter, ViewStream } from "spyne";

export class UiExternalEventsBtn extends ViewStream {
  constructor(props = {}) {
    const { externalEvent, externalEventVal } = props.data;
    props.tagName = "button";
    props.class = `external-event-btn event-btn-${externalEvent}`;
    props.dataset = {};
    props.dataset["btnType"] = "externalEvent";
    props.dataset["externalEvent"] = externalEvent;
    props.dataset["externalEventVal"] = externalEventVal;

    props.template = UiExternalEventsBtn.getTemplate(externalEvent);

    super(props);
  }

  static getTemplate(externalEvent = "copy") {
    const tmplHash = {
      copy: require("./templates/external-events-btn-copy.tmpl.html"),
      stackblitz: require("./templates/external-events-btn-stackblitz.tmpl.html"),
    };

    return tmplHash[externalEvent];
  }

  addActionListeners() {
    // return nexted array(s)

    const { parentVsid, codeBlockId } = this.props;
    //console.log("THIS DETAILS VSID ",parentVsid);
    const isContainerFilter = new ChannelPayloadFilter({
      payload: (v) => v.parentVsid === parentVsid,
    });
    const isCodeBlockIdFilter = new ChannelPayloadFilter({
      payload: (v) => v.codeBlockId === codeBlockId,
    });

    return [
      ["CHANNEL_CODE_GEN_DATA.*_EVENT", "onCodeLoaded", isContainerFilter],
      ["CHANNEL_ROUTE_CHANGE_EVENT", "onCodeLoaded"],
    ];
  }

  onCodeLoaded(e) {
   //console.log("EVENT BTN CODE LAODED ");
    this.disposeViewStream();
  }

  broadcastEvents() {
    // return nexted array(s)
    return [["button", "click"]];
  }

  onRendered() {
    this.addChannel("CHANNEL_CODE_GEN", true);
    this.addChannel("CHANNEL_ROUTE", true);
  }
}
